import store from "@/store";
import axios from "axios";

let baseURL = "https://pmtool.newance.be/api"
if(process.env.NODE_ENV === 'development') {
  baseURL = "http://pmtool-backend.test/api"
}

const customized = axios.create({
  baseURL: baseURL,
  headers: { "X-Requested-With": "XMLHttpRequest" }
});

// Configure defaults
// axios.defaults.headers.common[''] =
// axios.defaults.baseURL =

// If we have a jwt token, use it
customized.interceptors.request.use(
  config => {
    if (store.getters.isAuthenticated) {
      config.headers.Authorization = `Bearer ${store.state.jsonWebToken}`;
    }

    return config;
    // Do something with request error
  },
  error => Promise.reject(error)
);

// Set up a response interceptor to redirect on 401 responses
// Add a response interceptor
customized.interceptors.response.use(
  response => response,
  error => {
    if (navigator.onLine) {
      if(error.message = 'Network Error'){
        store.commit("clearAuthCredentials");
      }
      if (error.response.status === 401) {
        store.commit("clearAuthCredentials");
      }
      if (error.response.status > 400) {
        if (Object.prototype.hasOwnProperty.call(error.response.data, "message")) {
          // console.log('message')
        }
        if (Object.prototype.hasOwnProperty.call(error.response.data, "errors")) {
          store.commit("setFormErrors", error.response.data.errors);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default customized;
